export default function Footer() {
  return (
    <footer className="relative bg-background-200 py-12 px-4 md:px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-xl text-foreground-700 tracking-wider mb-4">
          湯の華
        </h2>
        <p className="text-foreground-500 text-xs tracking-wider mb-8">
          リラクゼーションエステ
        </p>

        <div className="flex items-center justify-center gap-6 mb-8">
          <a
            href="https://www.instagram.com/yunohana0873"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 flex items-center justify-center rounded-full bg-background-300/50 text-foreground-500 hover:text-primary-500 transition-colors duration-300 cursor-pointer"
            aria-label="Instagram"
          >
            <i className="ri-instagram-line text-lg"></i>
          </a>
          <a
            href="https://line.me/ti/p/zcTZh94HXd"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 flex items-center justify-center rounded-full bg-background-300/50 text-foreground-500 hover:text-accent-500 transition-colors duration-300 cursor-pointer"
            aria-label="LINE"
          >
            <i className="ri-line-line text-lg"></i>
          </a>
        </div>

        <div className="mb-8">
          <a
            href="https://esjob.jp/shop/50473/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-600 hover:text-primary-500 hover:border-primary-500 transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-briefcase-line text-base"></i>
            <span className="font-sans text-sm tracking-wider">求人情報</span>
          </a>
        </div>

        <div className="w-full h-[1px] bg-background-300 mb-6"></div>

        <p className="text-foreground-500 text-xs">
          &copy; 2026 リラクゼーションエステ湯の華. All rights reserved.
        </p>
      </div>
    </footer>
  );
}